// extracted by mini-css-extract-plugin
module.exports = {"pd":"pdfcss_pd__3HENv"};